const contactPhone = "8334331371"
export { contactPhone };